'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import {
  APP_MODAL_ROOT_ID,
  installModalLayerGuard,
  purgeStuckModalLayers,
} from '@/lib/modalScrollLock';

/** Conteneur portal — `contents` uniquement : pas de calque fixed plein écran (iOS PWA). */
export default function ModalPortalHost() {
  const pathname = usePathname();

  useEffect(() => {
    purgeStuckModalLayers();
    return installModalLayerGuard();
  }, []);

  useEffect(() => {
    purgeStuckModalLayers();
  }, [pathname]);

  return <div id={APP_MODAL_ROOT_ID} className="contents" aria-hidden />;
}
